<div class="position-relative">
  <div class="pageHeader" appStickyPageHeader>
    <ng-container *ngLet="(screenSizeService.isHandset$ | async) as isHandset">
      <div class="d-flex flex-wrap align-items-center w-100" [ngClass]="{'py-2': isHandset}">
        <div class="d-flex align-items-center" [ngClass]="{'w-100': isHandset}">
          <button mat-flat-button (click)="navigateToDprList()" class="button--square mr-3">
            <mat-icon svgIcon="arrow-left"></mat-icon>
          </button>

          <app-dpr-details-header
            [ngClass]="{'w-100': isHandset}"
            *ngIf="(loading$ | async) === false"
            [dprDetails]="dprDetails$ | async"
            [customNames]="selectedSubproject.data.subprojectConfiguration.customNames"
            [isHandset]="isHandset"
          ></app-dpr-details-header>
        </div>

        <hr *ngIf="isHandset" class="my-2 w-100" />

        <div class="ml-auto d-flex" [ngClass]="{'w-100': isHandset}">
          <div [ngClass]="{'mr-auto': isHandset}">
            <app-unsaved-changes></app-unsaved-changes>
          </div>

          <button
            *ngIf="!isHandset"
            data-testId="dpr-details-actions"
            class="button--square mat-secondary mx-2"
            mat-flat-button
            [matMenuTriggerFor]="dprActions"
          >
            <mat-icon svgIcon="dots-horizontal" class="icon--large"></mat-icon>
          </button>
          <mat-menu #dprActions="matMenu">
            <div
              [matTooltip]="canCopyDpr | copyFromPrevDprTooltip : isFirstDpr : selectedSubproject.dprScreen === Rights.Edit : (isAppOnline$ | async) : subprojectConfiguration.enableCopyDprDataFromPreviousDpr : !!dprDetails?.lockedDate"
            >
              <button
                data-testId="copy-from-previous-dpr"
                mat-menu-item
                [disabled]="!subprojectConfiguration.enableCopyDprDataFromPreviousDpr || !canCopyDpr || (isAppOnline$ | async) === false || isFirstDpr || selectedSubproject.dprScreen !== Rights.Edit"
                (click)="openCopyFromPreviousDprModal()"
              >
                <mat-icon svgIcon="content-copy"></mat-icon>
                <span>{{StaticMessage.CopyFromPreviousDprTooltip | staticMessage}}</span>
              </button>
            </div>
            <button data-testId="download-dpr-report" mat-menu-item (click)="downloadDprReport()">
              <mat-icon svgIcon="cloud-download"></mat-icon>
              <span i18n="@@dprDetails.dprDetailsPage.btnDownloadReport">Download report</span>
            </button>
          </mat-menu>

          <div>
            <button
              data-testId="next-dpr"
              mat-flat-button
              class="button--square mat-secondary nextDprButton"
              matTooltip="Next DPR"
              i18n-matTooltip="@@dprDetails.dprDetailsPage.btnNextDpr"
              (click)="goToNextDpr()"
              [disabled]="(isLastDpr$ | async) || (loading$ | async)"
              [matTooltipDisabled]="(isLastDpr$ | async) || (loading$ | async)"
              [class.borderActive]="!((isLastDpr$ | async) || (loading$ | async)) && !(isFirstDpr || (loading$ | async))"
              [class.borderDisabled]="((isLastDpr$ | async) || (loading$ | async)) || (isFirstDpr || (loading$ | async))"
            >
              <mat-icon svgIcon="chevron-left" class="icon--large"></mat-icon>
            </button>

            <button
              data-testId="previous-dpr"
              mat-flat-button
              class="button--square mat-secondary previousDprButton"
              matTooltip="Previous DPR"
              i18n-matTooltip="@@dprDetails.dprDetailsPage.btnPreviousDpr"
              (click)="goToPreviousDpr()"
              [disabled]="isFirstDpr || (loading$ | async)"
              [matTooltipDisabled]="isFirstDpr || (loading$ | async)"
            >
              <mat-icon svgIcon="chevron-right" class="icon--large"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="pageTabs">
    <nav
      *ngIf="(screenSizeService.isHandset$ | async) === false; else handsetTemplate"
      mat-tab-nav-bar
      mat-stretch-tabs="false"
      [tabPanel]="tabPanel"
    >
      <!-- isActiveChange will emit true when the link is activated and false when the link is deactivated, hence why we need the $event in the onSelectionChange method -->
      <a
        *ngFor="let item of (menuItems | filterByProperty : 'hasAccess' : true)"
        mat-tab-link
        [attr.data-testId]="item.dataTestId"
        routerLinkActive
        #rla="routerLinkActive"
        queryParamsHandling="merge"
        [routerLink]="[item.link]"
        [active]="rla.isActive"
        [ngClass]="{'cursor-pointer-none' : rla.isActive, 'active-nav-tab':rla.isActive}"
        (isActiveChange)="onSelectionChange(item.link, $event)"
      >
        <mat-icon [svgIcon]="item.icon"></mat-icon>
        <span [attr.data-testId]="item.dataTestId + '-name'">{{item.label}}</span>
      </a>
    </nav>
    <!-- hidden is used instead of ngIf to avoid unsubscribing from observables (by removing the grid from the DOM) when the data is reloaded -->
    <mat-tab-nav-panel #tabPanel>
      <router-outlet
        [hidden]="(loading$ | async) === true"
        (activate)="componentActivated($event)"
        (deactivate)="componentDeactivated()"
      ></router-outlet>
    </mat-tab-nav-panel>
  </div>
</div>

<ng-template #handsetTemplate>
  <app-navigation-select
    class="navigation-select"
    [useDeactivationGuard]="true"
    [items]="menuItems | filterByProperty : 'hasAccess' : true"
    [initialSelection]="preselectedItem"
    (selectedItemChanges)="onSelectionChange($event)"
  ></app-navigation-select>
</ng-template>
